import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-dark/90 backdrop-blur-md border-b border-dark-border" data-id="element-101">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex justify-between items-center h-20" data-id="element-103">
          <div className="flex-shrink-0 flex items-center" data-id="element-104">
            <span className="font-display font-bold text-2xl tracking-widest text-white" data-id="element-105">
              ODYSSEY
            </span>
          </div>
          <div className="flex items-center" data-id="element-106">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-accent hover:bg-accent-hover text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 text-sm sm:text-base" data-id="element-107">
              CONSIGUE EL LIBRO →
            </motion.button>
          </div>
        </div>
      </div>
    </nav>;
}